import {Component, Output, EventEmitter} from "@angular/core";

@Component({
  selector: "core-output-child",
  template: `
    <button (click)="output.emit('clicked')">Click</button>
    `,
})
class OutputChildComponent {
  @Output() output = new EventEmitter();
}

@Component({
  selector: "core-output",
  template: `
  <usecase-container title="Output" src="core/output">
    <usecase-content>
      <core-output-child (output)="text=$event"></core-output-child>
      <p>{{text}}</p>
    </usecase-content>
  </usecase-container>
  `,
  directives: [OutputChildComponent]
})
export class OutputComponent {
  private text = "";
}



/** WEBPACK FOOTER **
 ** ./script/core/output/component.ts
 **/